/**
 * App 启动期全局副作用（自 App.js 原样迁出，行为不变）：
 * - antd message 提示位置放到标题栏+导航栏下方
 * - dayjs 插件与兼容方法
 * 注意：App.js 在所有页面与样式 import 之后才 import 本模块，保持与原来相同的执行时机。
 */
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { message } from './antdMessage';

/** antd 全局提示：放在标题栏+导航栏下方，避免盖住顶栏标题 */
function applyMessageOffsetBelowHeader() {
  try {
    const raw = getComputedStyle(document.documentElement)
      .getPropertyValue('--header-total-height')
      .trim();
    const parsed = parseFloat(raw);
    // 默认约 60+32，再加一点间距
    const top = Number.isFinite(parsed) && parsed > 0 ? parsed + 12 : 104;
    message.config({ top, duration: 3, maxCount: 3 });
  } catch (_) {
    message.config({ top: 104, duration: 3, maxCount: 3 });
  }
}
applyMessageOffsetBelowHeader();
if (typeof window !== 'undefined') {
  window.addEventListener('resize', applyMessageOffsetBelowHeader);
}

// 配置 dayjs
dayjs.extend(isSameOrAfter);

// 为 dayjs 对象添加 isValid 方法
if (!dayjs.prototype.isValid) {
  dayjs.prototype.isValid = function() {
    if (!this || typeof this.valueOf !== 'function') {
      return false;
    }
    const timestamp = this.valueOf();
    return !isNaN(timestamp) && isFinite(timestamp);
  };
}

// 为 dayjs 对象添加 isAfter 方法
if (!dayjs.prototype.isAfter) {
  dayjs.prototype.isAfter = function(other) {
    if (!other || !other.valueOf) {
      return false;
    }
    return this.valueOf() > other.valueOf();
  };
}
